import { persistentAtom } from "@nanostores/persistent";
import { useStore } from "@nanostores/react";
import { type Address, type Hash, isAddressEqual } from "viem";
import { deserialize, serialize } from "wagmi";
import { LocalStorageKeys } from "./keys";

export type TokenRegTxHash = {
  l1TokenAddress: Address;
  proposedTxHash?: Hash;
  l1RegisteredTxHash?: Hash;
  l2RegisteredTxHash?: Hash;
};

const $tokenRegTxHashAtom = persistentAtom<TokenRegTxHash[]>(LocalStorageKeys.TOKEN_REG_TX_HASH_KEY, [], {
  encode: serialize,
  decode: deserialize,
});

export function useTokenRegTxHash(tokenAddress: Address) {
  const data = useStore($tokenRegTxHashAtom);
  return data.find((t) => isAddressEqual(t.l1TokenAddress, tokenAddress));
}

export function getTokenRegTxHash(): TokenRegTxHash[] {
  return $tokenRegTxHashAtom.get();
}

export function getTokenRegTxHashByL1TokenAddress(l1TokenAddress: Address): TokenRegTxHash | undefined {
  const tokenRegTxHashes = $tokenRegTxHashAtom.get();
  return tokenRegTxHashes.find((t) => isAddressEqual(t.l1TokenAddress, l1TokenAddress));
}

export function storeTokenRegTxHash(l1TokenAddress: Address, patch: Omit<TokenRegTxHash, "l1TokenAddress">) {
  const data = $tokenRegTxHashAtom.get();
  const tokenRegTxHash = data.find((t) => isAddressEqual(t.l1TokenAddress, l1TokenAddress));
  if (tokenRegTxHash) {
    Object.assign(tokenRegTxHash, patch);
  } else {
    data.push({ l1TokenAddress, ...patch });
  }
  $tokenRegTxHashAtom.set(data);
}
